var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { size } from 'polished';
import arrow from '../../assets/icons/arrow-left.svg';
export var ArrowIcon = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var arrowSize = _a.arrowSize;
    return size(arrowSize);
});
ArrowIcon.defaultProps = {
    arrowSize: '22px',
    src: arrow,
};
export default ArrowIcon;
var templateObject_1;
